module.exports = __webpack_public_path__ + "media/images/new_home/logo-f11dee670be12bb5de7d4f22f268dae7.png";